<template>
    <div id="content-main ms-font-m">
        <div class="padding ms-font-m">

            <br />

            <div class="ms-fontColor-neutralTertiary" style="text-align:center">
                Регистрация
                <br />
                <br />
                <img src="../../Images/ok.png" />
                <br />
                <div style="color: #18D8B3; font-size:x-large">Успешно!</div>
                <br />
                <img src="../../Images/logo.png" id="card-image" style="width:80%" />
            </div>
            <br />
            <div style="text-align: center; width: 100%">
                <button class="button" v-on:click="saveImage()" id="ready-button" style="margin:0 auto;margin-right: 5px;">Сохранить</button>
                <button class="button" v-on:click="printImage()" id="ready-button" style="margin:0 auto;margin-right: 5px;">Распечатать</button>
                <button class="button" v-on:click="emailPicture()" id="ready-button" style="margin:0 auto;margin-right: 5px;">Email</button>

            </div>

            <br />
            <br />


            <!--Дата регистрации-->
            <div class="ms-Grid-row ms-fontColor-neutralTertiary">
                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                    Дата регистрации
                </div>
            </div>
            <br />
            <div class="ms-Grid-row">
                <div id="when" class="ms-Grid-col ms-u-lg12 wrap">

                </div>
            </div>

            <br />

            <!--Место размещения-->
            <div class="ms-Grid-row ms-fontColor-neutralTertiary">
                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                    Место размещения
                </div>
            </div>
            <br />
            <div class="ms-Grid-row">
                <div id="link" class="ms-Grid-col ms-u-lg12 wrap">

                </div>
            </div>

            <br />

            <!-- Конечная сумма объекта-->
            <div class="ms-Grid-row ms-fontColor-neutralTertiary">
                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                    Конечная сумма объекта
                </div>
            </div>
            <br />
            <div class="ms-Grid-row">
                <div id="hash" class="ms-Grid-col ms-u-lg12 wrap">

                </div>
            </div>

            <br />

            <!-- Ключ доступа к объекту-->
            <div class="ms-Grid-row ms-fontColor-neutralTertiary">
                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                    Ключ доступа к объекту
                </div>
            </div>
            <br />
            <div class="ms-Grid-row">
                <div id="clue" class="ms-Grid-col ms-u-lg12 wrap">

                </div>
            </div>

            <br />

            <div style="text-align: center; width: 100%">
                <button class="button" v-on:click="goToHome()" id="ready-button" style="margin:0 auto;margin-right: 5px;">Готово</button>
                <!--<button class="button" v-on:click="saveImage()" id="ready-button" style="margin:0 auto;margin-right: 5px;">Сохранить</button>
                <button class="button" v-on:click="printImage()" id="ready-button" style="margin:0 auto;margin-right: 5px;">Распечатать</button>-->
            </div>

            <notifications group="foo" />
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    //import AuthSvc from '../classes/AuthSvcJ';
    var authors = [{ name: 'Иван', weight: 1 }, { name: 'Супер иван', weight: 0.5 }];
    //var iprights;
    const Word = window.Word;
    const Office = window.Office;
    import { sha256 } from 'js-sha256';
    import * as moment from 'moment';
    import AuthSvc from '../classes/AuthSvcJ';
    import NotificationsSvc from '../../src/classes/NotificationsSvcT'

    export default {
        data() {
            return {
                login: null,
                pass: null,
                docData: null,
                userData: null
            }
        },
        methods: {
            saveImage() {
                window.open(process.env.VUE_APP_ROOT_API + 'DownloadFileCard?uid=' + this.uid + '&clue=' + this.clue, 'Download', 'width=500,height=800,centerscreen=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,titlebar=0,dialog=1');
                ////debugger;
                ////var b64Data = 'data:image/png;base64, ' + this.docData.cardData;
                ////const byteCharacters = atob(b64Data);
                ////const byteNumbers = new Array(byteCharacters.length);
                ////for (let i = 0; i < byteCharacters.length; i++) {
                ////    byteNumbers[i] = byteCharacters.charCodeAt(i);
                ////}
                ////const byteArray = new Uint8Array(byteNumbers);
                ////const blob = new Blob([byteArray], { type: 'image/png' });

                ////var blob = new Blob([this.docData.cardData] , {type:'image/png'})

                //var byteString = atob(this.docData.cardData);
                //var ab = new ArrayBuffer(byteString.length);
                //var ia = new Uint8Array(ab);

                //for (var i = 0; i < byteString.length; i++) {
                //    ia[i] = byteString.charCodeAt(i);
                //}
                //var blob = new Blob([ab], { type: 'image/png' });

                //let link = document.createElement('a')
                ////Раскоментить для браузера
                ////if (link.download !== undefined) { // feature detection
                ////    // Browsers that support HTML5 download attribute
                ////    let url = URL.createObjectURL(blob)
                ////    link.setAttribute('href', url)
                ////    link.setAttribute('download', "Карточка документа")
                ////    link.style.visibility = 'hidden'
                ////    document.body.appendChild(link)
                ////    link.click()
                ////    document.body.removeChild(link)
                ////}
                ////else
                //{
                //    //saveAs(blob, "Карточка документа.png");
                //    var fileName = "Карточка документа.png"
                //    if (window.navigator.msSaveOrOpenBlob) { // IE only
                //        window.navigator.msSaveOrOpenBlob(blob, fileName);
                //    } else {
                //        const link = document.createElement('a');
                //        link.href = window.URL.createObjectURL(blob);
                //        link.download = fileName;
                //        link.click();
                //    }
                //}
            },
            printImage() {
                window.open(process.env.VUE_APP_ROOT_API + 'PrintFileCard?uid=' + this.uid + '&clue=' + this.clue, 'Download', 'width=500,height=800,centerscreen=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,titlebar=0,dialog=1');

                //var printContents = "<img src='" + 'data:image/png;base64, ' + this.docData.cardData + "'/>";
                //var popupWin = window.open('');
                //popupWin.document.open();
                //popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print();">');
                //popupWin.document.write(printContents);
                //popupWin.document.write('</body></html>');
                ////popupWin.document.title = "Карточка документа";

                //popupWin.document.close();
            },
            emailPicture() {
                $.get(process.env.VUE_APP_ROOT_API + 'api/emailPicture?uid=' + this.uid + '&clue=' + this.clue + '&ipchainid=' + this.userData.id,
                    function (result) {
                        NotificationsSvc.Notify('', 'Письмо отправлено на email указанный вами при регистрации');
                        var data = JSON.parse(result);
                });
            },
            errorHandler(error) {
                this.Notify("Error:", error);
            },

            Notify(header, text) {
                NotificationsSvc.Notify(header, text);
            },

            goToHome() {
                this.$router.push('/Home');
            }
        },
        mounted: function () {
            //if (!Office.context.requirements.isSetSupported('WordApi', '1.1')) {
            //    $('#highlight-button').click(this.getDocumentAsCompressed);
            //    return;
            //}

            // Add a click event handler for the highlight button.
            //$('#highlight-button').click(this.getDocumentAsCompressed);

            //var params = this.getUrlVars();

            var userDataStr = localStorage.getItem("userData");
            if (userDataStr) {
                this.userData = JSON.parse(userDataStr);
            }

            var params = this.$route.params;
            var that = this;
            this.clue = params['clue'];
            this.uid = params['uid'];

            $.get(process.env.VUE_APP_ROOT_API + 'api/objects?uid=' + params['uid'] + '&clue=' + params['clue'], function (result) {

                var data = JSON.parse(result);
                that.docData = data;
                var dateStr = moment(data.when).format('DD/MM/YYYY');
                $('#when').text(dateStr);
                $('#link').text(data.link);
                $('#hash').text(data.hash);
                $('#clue').text(data.clue);

                $('#card-image').attr('src', 'data:image/png;base64, ' + data.cardData);
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../../Content/Home.css';
    @import '../../Content/fabric.css';
    @import '../../Content/fabric.components.css';
    @import '../../Content/fabric.rtl.css';
</style>
